import { Button, Grid, Stack, Typography } from "@mui/material";
import React, { useMemo, useState } from "react";
import ImageViewer from "react-simple-image-viewer";
import {
  BREACH_STATUS,
  BreachStatusValue,
  IBreachDetails,
} from "./models/breach-details.interface";
import { useImageViewer } from "./hooks/useImageViewer";
import { PaymentFlow } from "./components/PaymentFlow/PaymentFlow";
import BreachStatusMessage from "./components/status-message/status-message";

interface IProps {
  details: IBreachDetails;
}

export const BreachDetails: React.FC<IProps> = (props: IProps) => {
  const { details } = props;
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const { currentImage, isViewerOpen, openImageViewer, closeImageViewer } =
    useImageViewer();

  const statusKey: BreachStatusValue = useMemo(
    () => +details.status.key,
    [details.status.key]
  );
  return (
    <Grid container>
      <Grid item sm={8} xs={12}>
        <Stack spacing={1}>
          <Grid container>
            <Grid item xs={6}>
              <Typography variant="body1" fontWeight="bold">
                Breach ID
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">{details.ticketNbr}</Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6}>
              <Typography variant="body1" fontWeight="bold">
                Car Rego
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">{details.vrm}</Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6}>
              <Typography variant="body1" fontWeight="bold">
                Make
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">{details.make}</Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6}>
              <Typography variant="body1" fontWeight="bold">
                Model
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">{details.model}</Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6}>
              <Typography variant="body1" fontWeight="bold">
                Colour
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1">{details.color}</Typography>
            </Grid>
          </Grid>
          <Typography variant="body1">
            Our records show that the above vehicle has parked in breach of the
            car park's terms and conditions, resulting in the following Breach
            Notice:
          </Typography>
          <Stack spacing={1}>
            <Typography variant="body1" fontWeight="bold">
              Breach Details
            </Typography>
            <Typography variant="body1">{details.details}</Typography>
            <Typography variant="body1" fontWeight="bold">
              Car Park Location
            </Typography>
            <Typography variant="body1">{details.location}</Typography>
            <Typography variant="body1" fontWeight="bold">
              Date of Breach Issue
            </Typography>
            <Typography variant="body1">{details.timeIn}</Typography>
            <Typography variant="body1" fontWeight="bold">
              Offence Date
            </Typography>
            <Typography variant="body1">{details.offenceTime}</Typography>
            <Typography variant="body1" fontWeight="bold">
              Amount
            </Typography>
            <Typography variant="body1">
              NZD$ {details.amount ? details.amount.toFixed(2) : 0}
            </Typography>

            {Object.values(BREACH_STATUS).includes(statusKey) ? (
              <BreachStatusMessage statusValue={statusKey} />
            ) : (
              <>
                <Stack direction={"row"} spacing={1}>
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={!details.amount}
                    onClick={() => setIsPaymentModalOpen(true)}
                    sx={{ mb: 2 }}
                  >
                    {details.amount ? "Pay" : "Nothing to pay"}
                  </Button>
                </Stack>

                {isPaymentModalOpen && (
                  <PaymentFlow
                    details={details}
                    open={isPaymentModalOpen}
                    onClose={() => setIsPaymentModalOpen(false)}
                  />
                )}
              </>
            )}
          </Stack>
        </Stack>
      </Grid>
      <Grid item sm={4} xs={12}>
        <Stack spacing={1}>
          <Typography variant="body1" fontWeight="bold">
            Photographic Evidence
          </Typography>
          {details.images.map((image, index) => (
            <img
              key={image}
              src={image}
              alt={image}
              onClick={() => openImageViewer(index)}
            />
          ))}
        </Stack>
        {isViewerOpen && (
          <ImageViewer
            src={details.images}
            currentIndex={currentImage}
            disableScroll={true}
            closeOnClickOutside={true}
            onClose={closeImageViewer}
          />
        )}
      </Grid>
    </Grid>
  );
};
